export const ADD_TO_CART = 'ADD_TO_CART';
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';
export const UPDATE_CART_QUANTITY = 'UPDATE_CART_QUANTITY';
export const CLEAR_CART = 'CLEAR_CART';
export const SAVE_SHIPPING_ADDRESS = 'SAVE_SHIPPING_ADDRESS';
export const CREATE_ORDER = 'CREATE_ORDER';
export const GET_MY_ORDERS = 'GET_MY_ORDERS';
export const GET_ALL_ORDERS = 'GET_ALL_ORDERS';
export const UPDATE_ORDER_STATUS = 'UPDATE_ORDER_STATUS';
export const ORDER_ERROR = 'ORDER_ERROR';
